import type { OtherStandardPaymentRange } from '@/modules/Contract/types'
import dayjs from 'dayjs'

export const scheduleRoot = (index: number) =>
    `order.products.[${index}].service_domain_metadata.other_standard_payment_schedule`

export const emptyRange = (): OtherStandardPaymentRange => ({
    start_date: dayjs(),
    end_date: dayjs().endOf('month'),
    price: 0,
})

export const dateValue = (value: OtherStandardPaymentRange['start_date']) => {
    if (!value) return ''
    return typeof value === 'string' ? value : value.format('YYYY-MM-DD')
}

export const formatPriceInput = (value?: number) =>
    Number(value || 0).toLocaleString('en-US')

export const parsePriceInput = (value: string) =>
    Number(value.replace(/[^\d]/g, '') || 0)
